/* 🤖 this file was generated by svg-to-ts */
export const matIconLaptopChromebook: {
  name: 'laptop-chromebook';
  data: string;
} = {
  name: 'laptop-chromebook',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M22 18V3H2v15H0v2h24v-2h-2zm-8 0h-4v-1h4v1zm6-3H4V5h16v10z"/></svg>`
};
